<template>
  <div>
    <!-- Creator list -->
    <div>
      <vs-table id="service-list" class="vs-con-loading__container" stripe :sst="true" maxHeight="800px"
        @search="updateSearchQuery" @change-page="handleChangePage" @sort="handleSort" :total="FilteredCount"
        :max-items="length" search :data="records">
        <template slot="header">
          <div class="mb-2 flex items-center">
            <div class="flex flex-wrap justify-between items-center">
              <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                <vs-dropdown vs-trigger-click class="cursor-pointer filter-font">
                  <div
                    class="p-4 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <span class="mr-2">
                      {{ page * length - (length - (FilteredCount && 1)) || 0 }}
                      -
                      {{ FilteredCount - page * length > 0 ? page * length : FilteredCount }}
                      of {{ total || 0 }}
                    </span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="handleChangeLength(10)">
                      <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(20)">
                      <span>20</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(50)">
                      <span>50</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(100)">
                      <span>100</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </div>
            <div v-if="checkPermissionSlug(['service_create'])" @click="addPage"
              class="btn-add-new p-2 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-primary border border-solid border-primary">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add {{ module_name }}</span>
            </div>
            <div class="flex flex-wrap items-center">
              <!-- Custom Pagination -->
              <vs-pagination v-if="FilteredCount" v-model="page" :total="totalPages"
                :max="totalPages / length > 7 ? 7 : 5" class="mt-1"></vs-pagination>
            </div>
          </div>
        </template>

        <template slot="thead">
          <vs-th>Sr#</vs-th>
          <vs-th sort-key="Creator.image">Service Name</vs-th>
          <vs-th sort-key="Creator.image">Service Image</vs-th>
          <vs-th>Collection Platform Fee</vs-th>
          <!-- <vs-th sort-key="Creator.image">Status</vs-th>            -->
          <vs-th v-if="checkPermissionSlug(['service_edit']) || checkPermissionSlug(['service_delete'])">Action</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
            <vs-td>
              {{ page * length - (length - i - 1) }}
            </vs-td>
            <vs-td>
              {{ tr.service_name }}
            </vs-td>
            <vs-td>
              <img :src="tr.service_image" class="rounded object-cover" height="150px" width="350px"
                :alt="tr.service_name" />
            </vs-td>
            <vs-td>
              {{ tr.collection_platform_fee || 0 }}
            </vs-td>
            <!-- <vs-td class="text-left">
              <vs-switch icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" color="primary" :value="tr.is_active" @click.stop="updateStatus(tr._id, !tr.is_active)">
                <span slot="on"></span>
                <span slot="off"></span>
              </vs-switch>
            </vs-td> -->

            <vs-td>
              <div class="inline-flex"
                v-if="checkPermissionSlug(['service_edit']) || checkPermissionSlug(['service_delete']) || checkPermissionSlug(['service_analytics'])">
                <vx-tooltip :text="`${module_name} Analytics`" v-if="checkPermissionSlug(['service_analytics'])">
                  <feather-icon @click.stop="toggleActivityModal(tr._id, $event)" icon="ActivityIcon"
                    svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" />
                </vx-tooltip>

                <vx-tooltip :text="`Edit ${module_name}`" v-if="checkPermissionSlug(['service_edit'])">
                  <feather-icon @click.stop="toggleEditModal(tr._id, $event)" icon="EditIcon"
                    svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" />
                </vx-tooltip>
                <vx-tooltip :text="`Delete ${module_name}`" v-if="checkPermissionSlug(['service_delete'])">
                  <feather-icon @click.stop="deleteRecord(tr._id)" icon="Trash2Icon"
                    svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" />
                </vx-tooltip>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'ServicesList',

  /** Data */
  data: () => ({
    order: [],
    length: 100,
    page: 1,
    search: '',
    module_name: 'Service'
  }),

  /** computed */
  computed: {
    ...mapState('gurudwaraServices', ['records', 'total', 'FilteredCount', 'listLoading']),
    ...mapGetters('auth', ['checkPermissionSlug']),
    totalPages() {
      return Math.ceil(this.FilteredCount / this.length)
    }
  },

  /** Functions */
  methods: {
    ...mapActions('gurudwaraServices', {
      get: 'get',
      delete: 'delete'
    }),

    /** Per Page Limit Change */
    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getData()
    },

    /** Page Change */
    handleChangePage(page) {
      this.page = page
      this.getData()
    },

    /** Sorting Table Data */
    handleSort(key, active) {
      if (!key) return
      this.page = 1
      this.order = [key, active === 'desc' ? 'DESC' : 'ASC']
      this.getData()
    },

    /** Search Query */
    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.getData()
    },

    /** Creator List API */
    getData() {
      this.get({
        // order: this.order,
        limit: this.length,
        page: this.page,
        search: this.search
      })
    },

    // Add Creator modal
    addPage() {
      this.$router.push(`/service/add`)
    },

    // Edit Creator modal
    toggleEditModal(id, event) {
      const editUrl = `/service/${id}/edit`
      if (event.ctrlKey || event.metaKey) {
        // Let browser handle the default Ctrl + Click behavior
        window.open(editUrl, '_blank')
      } else {
        // Navigate in the same tab
        this.$router.push(editUrl)
      }
    },

    // Activity Creator modal
    toggleActivityModal(id, event) {
      const url = `/service/${id}/analytics`
      if (event.ctrlKey || event.metaKey) {
        // Let browser handle the default Ctrl + Click behavior
        window.open(url, '_blank')
      } else {
        // Navigate in the same tab
        this.$router.push(url)
      }
    },

    /** Delete Creator Confirmation */
    deleteRecord(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Delete`,
        text: `Are you sure you want to delete this record?`,
        accept: () => this.deleteSingleRecord(id),
        acceptText: 'Delete'
      })
    },

    /** Delete Creator API */
    async deleteSingleRecord(id) {
      try {
        const { message } = await this.delete(id)
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
        this.getData()
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          position: 'top-center',
          time: 5000,
          icon: 'icon-alert-circle',
          color: 'primary'
        })
      }
    }
  },

  /** Watchers */
  watch: {
    listLoading() {
      if (this.listLoading) {
        this.$vs.loading({
          container: '#service-list',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#service-list > .con-vs-loading')
      }
    },
    page() {
      this.getData()
    }
  },

  /** On Rendering */
  mounted() {
    const creator = this.$route.query.creator
    if (creator) {
      // this.search = creator // Set the search filter to the creator's ID
      this.updateSearchQuery(creator)
      this.getData() // Fetch data with the new filter
    } else {
      this.getData() // Fetch data without any filter if no creator is selected
    }
  }
}
</script>
